import React from 'react';
import Modal from '../ui/Modal';
import Button from '../ui/Button';

export const UserConfirmationModal = ({ open, onClose, onConfirm, user, action, loading }) => {
    if (!open || !user) return null;

    const isEnable = action === 'enable';

    return (
        <Modal open={open} onClose={onClose} className="max-w-md w-full">
            <div className="px-6 py-4 border-b border-gray-200 dark:border-slate-700">
                <h3 className="text-lg font-medium text-gray-900 dark:text-slate-100">
                    {isEnable ? 'Enable User' : 'Disable User'}
                </h3>
            </div>
            <div className="px-6 py-4">
                <p className="text-sm text-gray-600 dark:text-slate-300">
                    Are you sure you want to {isEnable ? 'enable' : 'disable'} <strong>{user.firstname} {user.lastname}</strong> ({user.email})?
                </p>
            </div>
            <div className="px-6 py-4 border-t border-gray-200 dark:border-slate-700 flex justify-end gap-3 bg-gray-50 dark:bg-slate-800/50">
                <Button
                    variant="outline"
                    onClick={onClose}
                    disabled={loading}
                >
                    Cancel
                </Button>
                <Button
                    variant={isEnable ? 'primary' : 'danger'}
                    onClick={() => { onConfirm(); onClose(); }}
                    isLoading={loading}
                >
                    {isEnable ? 'Enable' : 'Disable'}
                </Button>
            </div>
        </Modal>
    );
};
